import { gql } from 'graphql-tag';

export const CREATE_EVENT_COLLECTION_FOLLOWING = gql`
  mutation createEventCollectionFollowing(
    $eventCollectionId: Int!
    $cityId: Int!
    $email: String
    $sourceUrl: String!
  ) {
    createEventCollectionFollowing(
      eventCollectionId: $eventCollectionId
      cityId: $cityId
      email: $email
      sourceUrl: $sourceUrl
    ) {
      success
      eventCollectionFollowing {
        id
      }
    }
  }
`;

export const DELETE_EVENT_COLLECTION_FOLLOWING = gql`
  mutation deleteEventCollectionFollowing(
    $citySlug: String!,
    $email: String!,
    $eventCollectionSlug: String!,
    $token: String!
  ) {
    deleteEventCollectionFollowing(
      citySlug: $citySlug,
      email: $email,
      eventCollectionSlug: $eventCollectionSlug,
      token: $token
    ) {
      success
      city {
        id
        title
      }
      eventCollection {
        id
        title
      }
    }
  }
`;
